import { render, staticRenderFns } from "./GeneralInfoItem.vue?vue&type=template&id=47354612&"
import script from "./GeneralInfoItem.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports